import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { HelmetProvider } from 'react-helmet-async';
import axios from 'axios';
axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById('root'));

// En producción mantenemos StrictMode.
// En desarrollo lo sacamos para que no duplique mounts/efectos.
const AppTree = (
  <HelmetProvider>
    <AuthProvider>
      <App />
    </AuthProvider>
  </HelmetProvider>
);

if (process.env.NODE_ENV === 'production') {
  root.render(
    <React.StrictMode>
      {AppTree}
    </React.StrictMode>
  );
} else {
  root.render(AppTree);
}

// ✅ Production safety: desregistrar cualquier Service Worker viejo y limpiar caches.
// Evita servir bundles stale después de deploys.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    } catch (err) {
      console.warn('[SW] unregister failed', err);
    }

    try {
      if (window.caches && caches.keys) {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
    } catch (err) {
      console.warn('[SW] cache cleanup failed', err);
    }
  });
}